import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function OfferSection() {
  return <section id="offer" className="bg-gradient-hero py-20 md:py-28 px-4 md:px-8 relative overflow-hidden" data-id="element-173">
      {/* Decorative Gold Blob — softened */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/[0.06] blur-[120px] rounded-full pointer-events-none" data-id="element-174" />

      <div className="max-w-md mx-auto relative z-10" data-id="element-175">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="card-premium !border-gold/25 px-7 py-12 md:px-10 md:py-14 shadow-gold text-center space-y-8" data-id="element-176">
          {/* Eyebrow */}
          <p className="uppercase tracking-[0.28em] font-semibold text-[#C8A870] text-[14px]" data-id="element-177">
            Acceso completo al Protocolo H.E.R.
          </p>

          {/* Precio ancla */}
          <p className="text-foreground/35 font-body font-medium line-through decoration-foreground/20 decoration-1 text-[20px]" data-id="element-178">
            $44.000 ARS
          </p>

          {/* HOY */}
          <p className="uppercase tracking-[0.24em] text-foreground/60 font-semibold -mt-2 text-[14px]" data-id="element-179">
            Hoy
          </p>

          {/* Precio actual */}
          <div className="space-y-2" data-id="element-180">
            <p className="text-6xl md:text-7xl font-display font-semibold text-gradient-gold leading-none" data-id="element-181">
              $12.000
            </p>
            <p className="font-body text-[14px] text-foreground/50 tracking-wide" data-id="element-182">
              ARS · pago único
            </p>
          </div>

          {/* Cuotas */}
          <p className="font-body md:text-[16px] text-[#C8A870] text-[17px]" data-id="element-183">
            O en <span className="font-semibold" data-id="element-184">3 cuotas de $4.000</span> con
            Mercado Pago
          </p>

          {/* Frase emocional */}
          <p className="font-display italic md:text-[18px] max-w-xs mx-auto text-[#F0E8D8] text-[18px]" data-id="element-185">
            Menos que una consulta nutricional. Acceso de por vida a H.E.R.
          </p>

          {/* Precio de lanzamiento */}
          <p className="font-body tracking-wide text-[#C8A870] text-[14px]" data-id="element-186">
            📩 Acceso inmediato. Recibís el Protocolo H.E.R. por email apenas se
            aprueba el pago.
          </p>

          {/* CTA */}
          <div className="pt-2" data-id="element-187">
            <CTAButton section="offer" className="w-full text-[16px] md:text-[17px]" data-id="element-188">
              Acceder al Protocolo H.E.R.
            </CTAButton>
          </div>

          {/* Trust image — Mercado Pago (diseño completo en la imagen) */}
          <img src="https://cdn.magicpatterns.com/uploads/1a9ZqWHLFGeJEBrZWczanr/mp.webp" alt="Compra protegida con Mercado Pago — Pago seguro. Podés pagar con Visa, Mastercard, American Express, Cabal y más." loading="lazy" decoding="async" style={{
          width: '100%',
          maxWidth: '430px',
          height: 'auto',
          display: 'block',
          margin: '20px auto 0'
        }} data-id="element-189" />

          {/* Divider */}

          {/* Garantía */}
          <div className="space-y-3 pt-4" data-id="element-190">
            <p className="uppercase tracking-[0.22em] text-[#C8A870] font-semibold text-[14px]" data-id="element-191">
              ✦ Garantía de 30 días
            </p>
            <p className="font-body md:text-[15px] max-w-sm mx-auto text-[#F0E8D8] text-[15px]" data-id="element-192">
              Probalo durante 30 días. Si H.E.R. no es para vos, te devolvemos
              el 100% de tu dinero.
            </p>
          </div>

          {/* Footer */}
          <p className="text-[13px] font-body pt-4 text-[#F0E8D8]" data-id="element-193">
            🔒 Pago seguro con{' '}
            <span className="font-semibold" data-id="element-194">Mercado Pago</span>
          </p>
        </motion.div>
      </div>
    </section>;
}